import React, { useState, useEffect } from 'react';
import { navigate } from 'gatsby';

const ClientOnly = ({ children }) => {
    const [hasMounted, setHasMounted] = useState(false);

    useEffect(() => {
        setHasMounted(true);
    }, []);

    if (!hasMounted) {
        return null;
    }

    return children;
};

// checking if the user is logged in based on the expiration of their token

function isLoggedIn() {
    if (typeof window !== 'undefined' && localStorage.getItem('cid')) {
        let expiresAtDate = new Date(
            JSON.parse(localStorage.getItem('cid')).expiresAt
        ).valueOf();
        let today = new Date();
        today = today.valueOf();

        if (expiresAtDate > today) {
            return true;
        }
    } else {
        return false;
    }
}

const LoggedOutRoute = ({ component: Component, location, ...rest }) => {
    if (isLoggedIn()) {
        navigate('/accounts/dashboard');
        return null;
    }
    return (
        <ClientOnly>
            <Component {...rest} />
        </ClientOnly>
    );
};

export default LoggedOutRoute;
